import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { Injectable } from '@angular/core';
import { LoggedService } from '../services/logged.service';
import { SnackbarService } from '../services/snackbar.service';

@Injectable()
export class LoggedGuard  {

    constructor(
        private configService: ConfigService,
        private loggedService: LoggedService,
        private snackBarService: SnackbarService,
        private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

        const currentUrl = state.url;

        if (this.loggedService.validToken()) {

            const urlCambiarContraseña = this.configService.etiquetas.CambiarClave.Path;

            const ExpiredPassword = this.loggedService.logged.expiredPassword;
            const NewUser = this.loggedService.logged.newUser;

            if (ExpiredPassword) {

                if (currentUrl !== urlCambiarContraseña) {
                    this.router.navigateByUrl(urlCambiarContraseña);

                    this.snackBarService.openSnackbar(this.configService.mensajes.TituloInfo, this.configService.mensajes.LoginUsuario.ContraseñaExpirada, 2, 1);
                    return false;
                }
            }

            if (NewUser) {

                if (currentUrl !== urlCambiarContraseña) {
                    this.router.navigateByUrl(urlCambiarContraseña);

                    //this.snackBarService.openSnackbar( this.configService.mensajes.TituloError,this.configService.mensajes.LoginUsuario.ContraseñaExpirada);
                    return false;
                }
            }

            return true;
        }
        else if (currentUrl == "/") {
            localStorage.setItem('logoutLogs', JSON.stringify(
            {
                timestamp: new Date(),
                reasonId: 0,
                source: 'logged.guard.ts'
            }
            ));
    
            this.loggedService.logOut(0);

        }
        else {
            localStorage.setItem('logoutLogs', JSON.stringify(
            {
                timestamp: new Date(),
                reasonId: 2,
                source: 'logged.guard.ts'
            }
            ));
            
            this.loggedService.logOut(2);
        }

    }
}